"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var CaretDown = function CaretDown(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/caret_down-caret-down" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-caret-down" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.7855576,20.1209054 L16.1211626,20.7853004 C15.9259005,20.9805625 15.609318,20.9805625 15.4140558,20.7853004 L7.53859885,12.9098434 C7.21669494,12.5858963 7.05574299,12.2619491 7.05574299,11.938002 C7.05574299,11.6140549 7.21669494,11.2901077 7.53859885,10.9661606 L15.4140558,3.09070362 C15.609318,2.89544147 15.9259005,2.89544147 16.1211626,3.09070362 L16.7853004,3.75535574 C16.9804621,3.9505175 16.9805772,4.26690173 16.7855574,4.46220535 L9.32113867,11.938002 L16.7855574,19.4137987 C16.9805772,19.6091023 16.9804621,19.9254865 16.7853004,20.1206483 Z",
    fill: "inherit",
    id: "path-1-caret-down" + unique,
    transform: "translate(11.993745, 11.938002) scale(-1, -1) rotate(-270.000000) translate(-11.993745, -11.938002) "
  }))));
};

CaretDown.propTypes = propTypes;
var _default = CaretDown;
exports["default"] = _default;